/* istanbul ignore file */
import { useShowContext } from 'framework/show';
import { ListField, TextField } from 'framework/ui/field';
import { EmployeeLinkFieldWithAccessCheck } from 'domain/shared/employee';

const EmployeePeopleManagersField = (props: any) => {
  const { data: showData } = useShowContext();
  const hasSpecificManagers = showData?.getValueBySource('hasSpecificManagers');

  return !hasSpecificManagers ? (
    <TextField value="People management team" label="" />
  ) : (
    <ListField source="assignedPeopleManagerAliases" label="People managers">
      <EmployeeLinkFieldWithAccessCheck />
    </ListField>
  );
};

export default EmployeePeopleManagersField;
